import { colorToArray } from "./src/Animation";

interface Color {
    r: number;
    g: number;
    b: number;
}

function createColor(value: number) {
    const color = {
      r: (value >> 16) & 0xFF, g: (value >> 8) & 0xFF, b: value & 0xFF,
      toRGB() { return (this.r << 16) | (this.g << 8) | this.b },
      add(r: number, g: number, b: number) {
        this.r += r;
        this.g += g;
        this.b += b;
        this.clamp();
      },
      set(r: number, g: number, b: number) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.clamp();
      },
      clamp() {
        if (this.r > 255) {
          this.r = 255;
        }

        if (this.g > 255) {
          this.g = 255;
        }

        if (this.b > 255) {
          this.b = 255;
        }

        if (this.r < 0) {
          this.r = 0;
        }

        if (this.g < 0) {
          this.g = 0;
        }

        if (this.b < 0) {
          this.b = 0;
        }
      }
    }
    return color;
  }

function rgbToHsl(color: Color) {
    let r = color.r;
    let g = color.g;
    let b = color.b;
    r /= 255, g /= 255, b /= 255;

    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h: number = 0, s, l = (max + min) / 2;

    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }

      h /= 6;
    }

    return [ h, s, l ];
  }

  function hslToRgb(h: number, s: number, l: number) {
    var r, g, b;

    if (s == 0) {
      r = g = b = l; // achromatic
    } else {
      function hue2rgb(p: number, q: number, t: number) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1/6) return p + (q - p) * 6 * t;
        if (t < 1/2) return q;
        if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
      }

      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;

      r = hue2rgb(p, q, h + 1/3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1/3);
    }

    return [ r * 255, g * 255, b * 255 ];
  }

  function contrastAndBrightness(color: Color, contrast: number, brightness: number) {
      const factor = (259 * (contrast + 255)) / (255 * (259 - contrast))
      let newRed   = (factor * (color.r - 128) + 128 + brightness);
      let newGreen = (factor * (color.g - 128) + 128 + brightness);
      let newBlue  = (factor * (color.b - 128) + 128 + brightness);

      if (newRed < 0) {
        newRed = 0;
      }

      if (newRed > 255) {
        newRed = 255;
      }

      if (newGreen < 0) {
        newGreen = 0;
      }

      if (newGreen > 255) {
        newGreen = 255;
      }

      if (newBlue < 0) {
        newBlue = 0;
      }

      if (newBlue > 255) {
        newBlue = 255;
      }

      color.r = newRed;
      color.g = newGreen;
      color.b = newBlue;

      return color;
  }


export function coerceStellaColor(colorValue: number) {
    const color = createColor(colorValue);

    color.add(128, 128, 128);

    const [h, s, l] = rgbToHsl(color);

    let brightness = (-l) * 255;

    if (brightness < 0) {
        brightness = 0;
    }

    if (brightness > 255) {
        brightness = 255;
    }

    console.log(brightness);

    contrastAndBrightness(color, 20, brightness);

    console.log(color);

    let [h2, s2, l2] = rgbToHsl(color);

    s2 *= 5;

    if (s2 > 1) {
        s2 = 1;
    }

    console.log(s2);

    const [r, g, b] = hslToRgb(h2, s2, l2);
    color.r = r;
    color.g = g;
    color.b = b;

    return color.toRGB();
}